<template>
    <modal-form v-model="show" :submit="submit" size="md">
      <template v-if="hasEdit" v-slot:title>
        {{ model.Codigo ? "Editar" : "Incluir" }} Documento
      </template>
      <template v-else v-slot:title>
          Documento
      </template>
      <template v-slot:body>
        <v-row>
          <v-col cols="6">
            <template v-if="hasEdit">
              <template v-if="!model.Codigo">
                <input-select
                  required
                  :options="listaDocumentos.map(doc => ({ value: doc.value, text: doc.text }))"
                  label="Tipo de Documento"
                  v-model="model.TipoDocumento"
                  @change="getNomeDocumento"
                />
              </template>
              <template v-else>
                <input-text label="Tipo de Documento" :value="model.TipoDocumentoDescricao" readonly disabled/>
              </template>
            </template>
            <template v-else>
              <input-select
                required
                :options="listaDocumentos.map(doc => ({ value: doc.value, text: doc.text }))"
                label="Tipo de Documento"
                v-model="model.TipoDocumento"
                @change="getNomeDocumento"
              />
            </template>
          </v-col>

          <v-col cols="12">
            <input-file required label="Arquivo" v-model="arquivo" :accept="allowedFiles" :max-size="fileSize" @change="file => getDocumento(file)"/>
          </v-col>

          <v-col cols="8">
            <input-text label="Nome do Arquivo" disabled :value="nomeArquivo" allow-special-chars/>
          </v-col>

          <v-col cols="4">
            <input-date :max="null" :min="dtMin" label="Válido até" v-model="model.DtValidade" :required="validadeRequired"/>
          </v-col>
        </v-row>
      </template>
    </modal-form>
  </template>

<script>
export default {
  props: {
    tipo: { type: Object, required: true }, // se é pessoa ou se é proposta
    codigoProposta: { type: String, default: null },
    documentoCliente: { type: String, default: null },
    codigoVeiculo: { type: String, default: null },
    codigoPessoa: { type: String, default: null },
    hasEdit: { type: Boolean, default: false },
    validadeRequired: { type: Boolean, default: false },
    isAvalista: { type: Boolean, default: false },
    isVeiculo: { type: Boolean, default: false },
    isVeiculoZeroKM: { type: Boolean, default: false },
    hasConjuge: { type: Boolean, default: false },
    avalistaConjuge: { type: Object, default: null },
    papelAvalista: null,
    nomeAvalista: { type: String, default: null }
  },
  data () {
    return {
      dtMin: this.$api.UI.Date.DataAtual('yyyy-MM-dd'),
      show: false,
      model: {},
      arquivo: null,
      nomeArquivo: null,
    };
  },
  computed: {
    tipoPessoa () {
      return this.$api.UI.Format.SomenteNumeros(this.documentoCliente).length === 11 ? this.$aux.TipoPessoaEnum.PF : this.$aux.TipoPessoaEnum.PJ
    },
    tipoDocumentoEscolhido () {
      return this.$param[this.tipo.listaDocumentos]?.find(
        (el) => el.value === this.model.TipoDocumento
      ) ?? { text: 'TIPO DOCUMENTO', value: null };
    },
    papelDoAvalista () {
      if ((typeof this.papelAvalista === 'string' && this.papelAvalista.includes(',')) || (Array.isArray(this.papelAvalista) && this.papelAvalista.length > 1)) {
        return 'ambos'
      } else if (typeof this.papelAvalista === 'string' && this.papelAvalista.includes('REPRESENTANTE LEGAL')) {
        return 'REPRESENTANTE LEGAL'
      } else if (Array.isArray(this.papelAvalista)) {
        return this.papelAvalista[0]
      } return this.papelAvalista
    },
    listaDocumentos () {
      if (this.isVeiculo && this.isVeiculoZeroKM) {
        return this.$param.ListaDocumentoProposta.filter((doc) => doc.isVeiculo === true && doc.isVeiculoZeroKm);
      } else if (this.isVeiculo && !this.isVeiculoZeroKM) {
        return this.$param.ListaDocumentoProposta.filter((doc) => doc.isVeiculo === true && !doc.isVeiculoZeroKm);
      } else if (this.papelDoAvalista === 'ambos') {
        return this.$param.ListaDocumentoProposta.filter((doc) => doc.papelAvalista === 'AVALISTA' || doc.papelAvalista === 'REPRESENTANTE LEGAL' || (doc.hasConjuge === this.hasConjuge && this.hasConjuge === true));
      } else if (this.tipo === this.$aux.TipoDocumentoEntidade.Proposta && this.isAvalista && this.tipoPessoa === this.$aux.TipoPessoaEnum.PJ) {
        return this.$param.ListaDocumentoProposta.filter((doc) => doc.papelAvalista === 'AVALISTA');
      } else if (this.tipo === this.$aux.TipoDocumentoEntidade.Proposta && this.isAvalista) {
        return this.$param.ListaDocumentoProposta.filter((doc) =>
          (doc.hasConjuge === this.hasConjuge && this.hasConjuge === true) ||
            (doc.papelAvalista === this.papelDoAvalista && (doc.tipoPessoa === this.tipoPessoa || doc.tipoPessoa === this.$aux.TipoEntidadeDocumentoEnum.DocumentosAmbos))
        );
      } else if (this.tipo === this.$aux.TipoDocumentoEntidade.Proposta && !this.isAvalista) {
        return this.$param.ListaDocumentoProposta.filter((doc) => !doc.papelAvalista && !doc.tipoPessoa);
      }
      return this.$param.ListaDocumentoEmitente.filter((doc) =>
        !doc.tipoPessoa || doc.tipoPessoa === this.tipoPessoa || doc.tipoPessoa === this.$aux.TipoEntidadeDocumentoEnum.DocumentosAmbos
      );
    },
  },
  methods: {
    openModal (sender) {
      const th = this
      th.nomeArquivo = ''
      th.model = {}
      th.model.TipoDocumento = ''
      if (sender) {
        th.model = sender
        th.$set(th, 'nomeArquivo', th.model?.NomeArquivo)
        if (th.hasEdit) {
          const tipoDocumento = th.$param[th.tipo.listaDocumentos]?.find(
            (el) => el.value === th.model.TipoDocumento
          )
          th.model.TipoDocumento = tipoDocumento.value
        }
      }
      th.show = true
    },
    getParameters () {
      const th = this
      if (th.tipo === th.$aux.TipoDocumentoEntidade.Pessoa && th.codigoPessoa) {
        return {
          parameters: [
            { name: 'CodigoPessoa', value: th.codigoPessoa },
            { name: 'CodigoProposta', value: th.codigoProposta },
          ],
        };
      } else if (th.tipo === th.$aux.TipoDocumentoEntidade.Proposta && th.codigoProposta) {
        return {
          parameters: [{ name: 'CodigoProposta', value: th.codigoProposta }],
        };
      }
    },
    gerarNomeSequencial (nomeBase, listaExistente) {
      const nomes = listaExistente.map(doc => doc.NomeArquivo);

      let contador = 0;
      let novoNome = nomeBase;

      while (nomes.includes(novoNome)) {
        contador++;
        novoNome = `${nomeBase} ${contador}`;
      }

      return novoNome;
    },
    getDocumento (file) {
      const th = this;
      th.$api.Documento.GetFile(th.model, file)
    },
    getNomeDocumento () {
      const th = this
      if (this.isVeiculo) {
        th.$set(th, 'nomeArquivo', `${th.tipoDocumentoEscolhido.text} - ${th.codigoVeiculo}`)
      } else if (th.isAvalista && th.hasConjuge && th.tipoDocumentoEscolhido.text.includes('Cônjuge')) {
        th.$set(th, 'nomeArquivo', `${th.tipoDocumentoEscolhido.text} de ${th.nomeAvalista} - ${th.avalistaConjuge.NomeConjuge.toUpperCase()}`)
      } else if (th.isAvalista) {
        th.$set(th, 'nomeArquivo', `${th.tipoDocumentoEscolhido.text} - ${th.nomeAvalista}`)
      } else {
        const dto = th.getParameters();
        th.$api.Multiplo.Post(th.tipo.apiEndpoint, dto).then(async function (responseLeitura) {
          if (th.$api.UI.PostLoadData(responseLeitura)) {
            !th.model.TipoDocumento ? th.$set(th, 'nomeArquivo', null) : th.$set(th, 'nomeArquivo', `${th.gerarNomeSequencial(th.tipoDocumentoEscolhido.text, responseLeitura.Data) || ''}`)
          }
        })
      }
    },
    submit () {
      const th = this;
      const obj = {
        dto: {
          ...(th.tipo === th.$aux.TipoDocumentoEntidade.Pessoa
            ? { DocumentoCliente: th.documentoCliente }
            : { CodigoProposta: th.codigoProposta }),
        },
        documento: {
          ...th.model,
          NomeArquivo: th.nomeArquivo
        },
      };
      th.$api.Multiplo.PostFile(th.tipo.apiEndpointDocumentoEdit, obj).then((response) => {
        if (th.$api.UI.PostLoadData(response)) {
          th.show = false;
          th.model = {}
          th.nomeArquivo = ''
          th.$emit('close', !response.error);
        }
      });
    },
  },
};
</script>
